import React, { useState, useEffect, useRef } from 'react';
import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove, Timestamp, onSnapshot, writeBatch, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../servicios/firebase';
import { FaBan, FaTicketAlt, FaUnlock, FaWhatsapp, FaCheckCircle, FaArrowLeft, FaFilePdf, FaSyncAlt, FaClock, FaRoute, FaBus } from 'react-icons/fa';
import jsPDF from 'jspdf';

const getQrUrl = (texto) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=200x200&margin=4&data=${encodeURIComponent(texto)}`;

const SEAT_MAP = [
  ['conductor', 'p', 'a1', 'a2'],
  ['a3', 'a4', 'p', 'puerta'],
  ['a5', 'a6', 'p', 'puerta'],
  ['a7', 'a8', 'p', 'a9'],
  ['a10', 'a11', 'p', 'a12'],
  ['a13', 'a14', 'a15', 'a16'],
];

const generarIdTicket = () => Math.random().toString(36).substring(2, 10).toUpperCase();

const SESSION_ID = `taquilla_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

function AsientoTimer({ expiresAt }) {
  const [remaining, setRemaining] = useState(0);
  useEffect(() => {
    if (!expiresAt) return;
    const update = () => {
      const diff = Math.max(0, Math.floor((new Date(expiresAt) - Date.now()) / 1000));
      setRemaining(diff);
    };
    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, [expiresAt]);
  if (!remaining) return null;
  const mins = Math.floor(remaining / 60);
  const secs = (remaining % 60).toString().padStart(2, '0');
  return (
    <span className="absolute -top-1.5 -right-1.5 bg-orange-500 text-white text-[7px] font-black rounded-full px-1 py-0.5 leading-none shadow z-20">
      {mins}:{secs}
    </span>
  );
}

const ModalAsientos = ({ viaje, onClose, onVentaExitosa, asientosResaltar = [] }) => {
  const [loading, setLoading] = useState(false);
  const [modo, setModo] = useState('VENTA');

  const [listaOcupadosIda, setListaOcupadosIda] = useState([]);
  const [listaBloqueadosIda, setListaBloqueadosIda] = useState([]);
  const [seleccionadosIda, setSeleccionadosIda] = useState([]);
  const [fullOcupadosIda, setFullOcupadosIda] = useState([]);
  const [fullBloqueadosIda, setFullBloqueadosIda] = useState([]);

  const [tempSeleccionesIda, setTempSeleccionesIda] = useState({});
  const [tempSeleccionesRegreso, setTempSeleccionesRegreso] = useState({});

  const [fechaRegreso, setFechaRegreso] = useState("");
  const [viajesRegresoOpciones, setViajesRegresoOpciones] = useState([]);
  const [regresoSeleccionado, setRegresoSeleccionado] = useState("");
  const [buscandoRegresos, setBuscandoRegresos] = useState(false);

  const [regresoData, setRegresoData] = useState(null);
  const [listaOcupadosRegreso, setListaOcupadosRegreso] = useState([]);
  const [listaBloqueadosRegreso, setListaBloqueadosRegreso] = useState([]);
  const [seleccionadosRegreso, setSeleccionadosRegreso] = useState([]);

  const [mapaVista, setMapaVista] = useState('IDA');
  const [precioRedondoDB, setPrecioRedondoDB] = useState(viaje.precio * 2);
  const [nombresPax, setNombresPax] = useState({});
  const [telefonoPax, setTelefonoPax] = useState("");
  const [motivoBloqueo, setMotivoBloqueo] = useState("");

  const [tipoDetalle, setTipoDetalle] = useState(null);
  const [ticketsGenerados, setTicketsGenerados] = useState(null);
  const [qrDataUrls, setQrDataUrls] = useState({});

  // ── Canal de venta ────────────────────────────────────────────────────────
  const [canalVenta, setCanalVenta] = useState('taquilla');
  const [canalVentaOtro, setCanalVentaOtro] = useState('');
  const [atendidoPor, setAtendidoPor] = useState('');

  // ── Liberación con/sin reembolso ──────────────────────────────────────────
  const [modoLiberacion, setModoLiberacion] = useState(null); // null | 'sin' | 'con'
  const [montoReembolso, setMontoReembolso] = useState('');
  const [motivoLiberacion, setMotivoLiberacion] = useState('');
  const [tipoReembolso, setTipoReembolso] = useState('total'); // 'total' | 'parcial'

  // ── NUEVO: resaltado de asientos desde notificación ───────────────────────
  const [resaltando, setResaltando] = useState([]);
  useEffect(() => {
    if (asientosResaltar.length === 0) return;
    setResaltando(asientosResaltar);
    const t = setTimeout(() => setResaltando([]), 4000);
    return () => clearTimeout(t);
  }, [asientosResaltar]);
  // ─────────────────────────────────────────────────────────────────────────

  const cleanupRef = useRef([]);

  const idViajeIda_Seguro = viaje.id || viaje.idReferencia || `${viaje.fecha}_${viaje.hora}_${viaje.rutaId}`;

  // ─── LISTENER IDA ─────────────────────────────────────────────────────────
  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'viajes', idViajeIda_Seguro), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setFullOcupadosIda(data.ocupados || []);
        setFullBloqueadosIda(data.bloqueados || []);
        setListaOcupadosIda((data.ocupados || []).map(p => typeof p === 'object' ? p.asiento : p));
        setListaBloqueadosIda((data.bloqueados || []).map(b => typeof b === 'object' ? b.asiento : b));
        setTempSeleccionesIda(data.tempSelecciones || {});
      }
    });
    return () => unsub();
  }, [idViajeIda_Seguro]);

  // ─── LISTENER REGRESO ─────────────────────────────────────────────────────
  useEffect(() => {
    if (!regresoSeleccionado) {
      setRegresoData(null);
      setListaOcupadosRegreso([]);
      setListaBloqueadosRegreso([]);
      setSeleccionadosRegreso([]);
      setTempSeleccionesRegreso({});
      return;
    }

    let unsubRegreso = null;

    const verificarViajeRegreso = async () => {
      const viajeRef = doc(db, 'viajes', regresoSeleccionado);
      const snap = await getDoc(viajeRef);

      if (snap.exists()) {
        unsubRegreso = onSnapshot(viajeRef, (realSnap) => {
          if (realSnap.exists()) {
            const realData = realSnap.data();
            setRegresoData({ id: realSnap.id, ...realData });
            setListaOcupadosRegreso((realData.ocupados || []).map(p => typeof p === 'object' ? p.asiento : p));
            setListaBloqueadosRegreso((realData.bloqueados || []).map(b => typeof b === 'object' ? b.asiento : b));
            setTempSeleccionesRegreso(realData.tempSelecciones || {});
          }
        });
      } else {
        const virtualViaje = viajesRegresoOpciones.find(v => v.id === regresoSeleccionado);
        if (virtualViaje) {
          setRegresoData(virtualViaje);
          setListaOcupadosRegreso([]);
          setListaBloqueadosRegreso([]);
          setTempSeleccionesRegreso({});
        }
      }
    };

    verificarViajeRegreso();
    return () => { if (unsubRegreso) unsubRegreso(); };
  }, [regresoSeleccionado, viajesRegresoOpciones]);

  // ─── TEMP TAQUILLA ────────────────────────────────────────────────────────
  const marcarTempTaquilla = async (viajeId, asientoId) => {
    if (!viajeId) return;
    try {
      await setDoc(doc(db, 'viajes', viajeId), {
        tempSelecciones: {
          [asientoId]: {
            sessionId: SESSION_ID,
            esTaquilla: true,
            timestamp: new Date().toISOString()
          }
        }
      }, { merge: true });
      const fn = () => limpiarTempTaquilla(viajeId, asientoId);
      cleanupRef.current.push(fn);
    } catch (e) {
      console.warn('No se pudo marcar temp taquilla:', e.message);
    }
  };

  const limpiarTempTaquilla = async (viajeId, asientoId) => {
    if (!viajeId) return;
    try {
      await updateDoc(doc(db, 'viajes', viajeId), {
        [`tempSelecciones.${asientoId}`]: null
      });
    } catch (e) { }
  };

  const limpiarTodosTemps = async () => {
    cleanupRef.current.forEach(fn => fn());
    cleanupRef.current = [];
  };

  useEffect(() => {
    return () => { limpiarTodosTemps(); };
  }, []);

  useEffect(() => {
    const fetchPrecios = async () => {
      const docSnap = await getDoc(doc(db, 'configuraciones', 'precios'));
      if (docSnap.exists() && docSnap.data().precioRedondo) setPrecioRedondoDB(docSnap.data().precioRedondo);
    };
    fetchPrecios();
  }, []);

  useEffect(() => {
    if (modo === 'REDONDO' && fechaRegreso) {
      const buscarRegresos = async () => {
        setBuscandoRegresos(true); setRegresoSeleccionado("");
        try {
          const limpiarTexto = (texto) => (texto ? texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : '');
          const qRutas = query(collection(db, 'rutas'), where('activo', '==', true));
          const rutasSnap = await getDocs(qRutas);
          const destinoLimpio = limpiarTexto(viaje.destino);
          const origenLimpio = limpiarTexto(viaje.origen);
          const rutasRegreso = [];
          rutasSnap.forEach(doc => {
            const data = doc.data();
            if (limpiarTexto(data.origen) === destinoLimpio && limpiarTexto(data.destino) === origenLimpio) {
              rutasRegreso.push({ id: doc.id, ...data });
            }
          });
          if (rutasRegreso.length === 0) return setViajesRegresoOpciones([]);
          const diaSemana = new Date(fechaRegreso + "T12:00:00").getDay();
          let opcionesGeneradas = [];
          for (const ruta of rutasRegreso) {
            if (ruta.diasOperacion && !ruta.diasOperacion.includes(diaSemana)) continue;
            if (ruta.horariosSalida) {
              for (const hora of ruta.horariosSalida) {
                const viajeId = `${fechaRegreso}_${hora}_${ruta.id}`;
                const viajeSnap = await getDoc(doc(db, 'viajes', viajeId));
                if (viajeSnap.exists()) opcionesGeneradas.push({ id: viajeId, ...viajeSnap.data() });
                else opcionesGeneradas.push({ id: viajeId, idReferencia: viajeId, rutaId: ruta.id, origen: ruta.origen, destino: ruta.destino, fecha: fechaRegreso, hora: hora, precio: viaje.precio, tipo: 'VIRTUAL', ocupados: [], bloqueados: [] });
              }
            }
          }
          opcionesGeneradas.sort((a, b) => a.hora.localeCompare(b.hora));
          setViajesRegresoOpciones(opcionesGeneradas);
        } catch (error) { console.error(error); } finally { setBuscandoRegresos(false); }
      };
      buscarRegresos();
    } else {
      setViajesRegresoOpciones([]); setRegresoSeleccionado("");
    }
  }, [fechaRegreso, modo, viaje.origen, viaje.destino, viaje.precio]);

  useEffect(() => {
    if (modo !== 'REDONDO') { setMapaVista('IDA'); setSeleccionadosRegreso([]); }
  }, [modo]);

  // ─── TOGGLE ASIENTO ───────────────────────────────────────────────────────
  const toggleAsiento = (asientoId) => {
    if (['conductor', 'p', 'puerta'].includes(asientoId)) return;
    const isIda = mapaVista === 'IDA';
    const viajeId = isIda ? idViajeIda_Seguro : regresoSeleccionado;
    const ocupados = isIda ? listaOcupadosIda : listaOcupadosRegreso;
    const bloqueados = isIda ? listaBloqueadosIda : listaBloqueadosRegreso;
    const seleccionados = isIda ? seleccionadosIda : seleccionadosRegreso;
    const setSel = isIda ? setSeleccionadosIda : setSeleccionadosRegreso;

    if (ocupados.includes(asientoId)) {
      if (isIda) {
        setSeleccionadosIda([asientoId]);
        setTipoDetalle('vendido');
        setModo('DETALLE');
        setNombresPax({});
      } else {
        alert("Este asiento de regreso ya está ocupado.");
      }
      return;
    }

    if (bloqueados.includes(asientoId)) {
      if (isIda) {
        setSeleccionadosIda([asientoId]);
        setTipoDetalle('bloqueado');
        setModo('DETALLE');
        setNombresPax({});
      } else {
        alert("Este asiento de regreso está bloqueado.");
      }
      return;
    }

    const temps = isIda ? tempSeleccionesIda : tempSeleccionesRegreso;
    const tempData = temps[asientoId];
    const selOtroOnline = tempData &&
      tempData.sessionId !== SESSION_ID &&
      !tempData.esTaquilla &&
      tempData.expiresAt &&
      new Date(tempData.expiresAt) > Date.now();

    if (selOtroOnline) {
      alert(`⏳ Este asiento está siendo seleccionado por un cliente online.`);
      return;
    }

    if (modo === 'DETALLE') {
      setSeleccionadosIda([asientoId]);
      setTipoDetalle(null);
      setModo('VENTA');
      setNombresPax({});
      return;
    }

    if (seleccionados.includes(asientoId)) {
      setSel(seleccionados.filter(id => id !== asientoId));
      limpiarTempTaquilla(viajeId, asientoId);
      if (isIda) {
        setNombresPax(prev => { const n = { ...prev }; delete n[asientoId]; return n; });
        if (seleccionadosRegreso.length > 0) setSeleccionadosRegreso(prev => prev.slice(0, -1));
      }
    } else {
      if (!isIda && seleccionadosRegreso.length >= seleccionadosIda.length) {
        return alert(`Solo puedes elegir ${seleccionadosIda.length} asiento(s) de regreso.`);
      }
      setSel([...seleccionados, asientoId]);
      marcarTempTaquilla(viajeId, asientoId);
    }
  };

  const handleNombreChange = (asiento, nombre) => setNombresPax(prev => ({ ...prev, [asiento]: nombre }));

  // ─── EJECUTAR ACCIONES ────────────────────────────────────────────────────
  const ejecutarAccion = async () => {
    if (seleccionadosIda.length === 0) return alert("Selecciona asientos en el mapa.");

    if (modo === 'VENTA' || modo === 'REDONDO') {
      for (let asiento of seleccionadosIda) {
        if (!nombresPax[asiento] || nombresPax[asiento].trim() === "") return alert(`Falta nombre del pasajero para asiento IDA ${asiento.replace('a', '')}`);
      }
      if (modo === 'REDONDO') {
        if (!regresoSeleccionado) return alert("Selecciona el horario de regreso.");
        if (seleccionadosIda.length !== seleccionadosRegreso.length) return alert(`Te falta seleccionar asientos en el mapa de REGRESO.`);
      }
    }

    setLoading(true);
    const docViajeIdaRef = doc(db, 'viajes', idViajeIda_Seguro);
    const batch = writeBatch(db);

    try {
      if (modo === 'VENTA' || modo === 'REDONDO') {
        const timestamp = Timestamp.now();
        const precioUnitario = modo === 'REDONDO' ? precioRedondoDB : viaje.precio;

        const nuevosPasajerosIda = [];
        const nuevosPasajerosRegreso = [];
        const infoTicketsGenerados = [];
        const nombreTitular = nombresPax[seleccionadosIda[0]];

        const limpiezaIda = {};
        seleccionadosIda.forEach(a => { limpiezaIda[`tempSelecciones.${a}`] = null; });

        for (let i = 0; i < seleccionadosIda.length; i++) {
          const asientoIda = seleccionadosIda[i];
          const asientoRegreso = modo === 'REDONDO' ? seleccionadosRegreso[i] : null;
          const nuevoIdTicket = generarIdTicket();
          const nombrePasajero = nombresPax[asientoIda];

          nuevosPasajerosIda.push({
            asiento: asientoIda, nombre: nombrePasajero, telefono: telefonoPax,
            ticketId: nuevoIdTicket, tipoPago: 'efectivo_taquilla', vendidoEn: timestamp, admin: 'Taquilla', tipoViaje: modo
          });

          if (modo === 'REDONDO') {
            nuevosPasajerosRegreso.push({
              asiento: asientoRegreso, nombre: nombrePasajero, telefono: telefonoPax,
              ticketId: nuevoIdTicket, tipoPago: 'efectivo_taquilla', vendidoEn: timestamp, admin: 'Taquilla', tipoViaje: 'redondo_regreso'
            });
          }

          const canalFinal = canalVenta === 'otro' ? (canalVentaOtro.trim() || 'otro') : canalVenta;
          const boletoData = {
            id: nuevoIdTicket, rutaId: viaje.rutaId || "manual", viajeId: idViajeIda_Seguro,
            tipoViaje: modo === 'REDONDO' ? 'redondo' : 'sencillo',
            fechaCompra: timestamp, estado: 'pagado',
            contacto: { nombre: nombreTitular, telefono: telefonoPax || "0000000000" },
            ruta: { origen: viaje.origen, destino: viaje.destino },
            fechaViaje: viaje.fecha, horaViaje: viaje.hora,
            fechaRegreso: modo === 'REDONDO' ? fechaRegreso : null,
            horaRegreso: modo === 'REDONDO' ? regresoData?.hora : null,
            rutaIda: modo === 'REDONDO' ? { origen: viaje.origen, destino: viaje.destino } : null,
            asientos: [asientoIda], pasajeros: { [asientoIda]: nombrePasajero },
            ocupados: [{ pasajero: nombrePasajero, asiento: asientoIda }],
            precioTotal: precioUnitario, metodoPago: 'efectivo_taquilla',
            // Canal de venta y quién atendió
            canalVenta: canalFinal,
            atendidoPor: atendidoPor.trim() || 'Taquilla',
            metodoVenta: 'fisica',
          };

          batch.set(doc(db, 'tickets', nuevoIdTicket), boletoData);

          infoTicketsGenerados.push({
            nombre: nombrePasajero, telefono: telefonoPax, asiento: asientoIda, precio: precioUnitario,
            idRef: nuevoIdTicket, tipoViaje: modo === 'REDONDO' ? 'redondo' : 'sencillo',
            fechaViaje: viaje.fecha, horaViaje: viaje.hora,
            origen: viaje.origen, destino: viaje.destino,
            fechaRegreso: fechaRegreso, horaRegreso: modo === 'REDONDO' ? regresoData?.hora : null, asientoRegreso: asientoRegreso
          });
        }

        batch.set(docViajeIdaRef, {
          id: idViajeIda_Seguro, rutaId: viaje.rutaId || "manual", origen: viaje.origen, destino: viaje.destino,
          fecha: viaje.fecha, hora: viaje.hora, precio: viaje.precio,
          ocupados: arrayUnion(...nuevosPasajerosIda),
          ...limpiezaIda
        }, { merge: true });

        if (modo === 'REDONDO' && regresoSeleccionado && regresoData) {
          const limpiezaRegreso = {};
          seleccionadosRegreso.forEach(a => { limpiezaRegreso[`tempSelecciones.${a}`] = null; });

          batch.set(doc(db, 'viajes', regresoSeleccionado), {
            id: regresoSeleccionado, rutaId: regresoData.rutaId || "manual", origen: regresoData.origen, destino: regresoData.destino,
            fecha: regresoData.fecha, hora: regresoData.hora,
            ocupados: arrayUnion(...nuevosPasajerosRegreso),
            ...limpiezaRegreso
          }, { merge: true });
        }

        await batch.commit();
        cleanupRef.current = [];
        setTicketsGenerados(infoTicketsGenerados);
        onVentaExitosa();
      }

      if (modo === 'BLOQUEO') {
        const motivo = motivoBloqueo.trim() || "Reservado Taquilla";
        const nuevosBloqueos = seleccionadosIda.map(asiento => ({
          asiento, motivo, admin: 'Taquilla', bloqueadoEn: Timestamp.now()
        }));
        const limpieza = {};
        seleccionadosIda.forEach(a => { limpieza[`tempSelecciones.${a}`] = null; });

        batch.set(docViajeIdaRef, {
          id: idViajeIda_Seguro, rutaId: viaje.rutaId || "manual", origen: viaje.origen, destino: viaje.destino,
          fecha: viaje.fecha, hora: viaje.hora, precio: viaje.precio,
          bloqueados: arrayUnion(...nuevosBloqueos),
          ...limpieza
        }, { merge: true });

        await batch.commit();
        cleanupRef.current = [];
        alert(`⛔ ${seleccionadosIda.length} Asiento(s) Bloqueado(s) — Motivo: ${motivo}`);
        setSeleccionadosIda([]); setNombresPax({}); setMotivoBloqueo("");
      }

      if (modo === 'DETALLE' && tipoDetalle === 'vendido') {
        const asientoId = seleccionadosIda[0];
        const objOcupado = fullOcupadosIda.find(o => (typeof o === 'object' ? o.asiento : o) === asientoId);
        const conReembolso = modoLiberacion === 'con';
        const montoFinal = conReembolso
          ? (tipoReembolso === 'total'
              ? (objOcupado?.precioTotal || 0)
              : parseFloat(montoReembolso) || 0)
          : 0;
        try {
          if (objOcupado?.ticketId) {
            await updateDoc(doc(db, 'tickets', objOcupado.ticketId), {
              estado: conReembolso ? 'cancelado_con_reembolso' : 'cancelado_sin_reembolso',
              canceladoEn: Timestamp.now(),
              canceladoPor: atendidoPor.trim() || 'Taquilla',
              canceladoTipo: 'liberacion_manual',
              motivoCancelacion: motivoLiberacion.trim() || (conReembolso ? 'Cliente canceló — reembolso aplicado' : 'Cliente no se presentó / sin reembolso'),
              reembolso: conReembolso ? {
                aplicado: true,
                monto: montoFinal,
                tipo: tipoReembolso,
                fecha: Timestamp.now(),
                por: atendidoPor.trim() || 'Taquilla',
              } : { aplicado: false, monto: 0 },
            });
          }
          if (objOcupado) {
            await updateDoc(docViajeIdaRef, { ocupados: arrayRemove(objOcupado) });
          } else {
            await updateDoc(docViajeIdaRef, { ocupados: arrayRemove(asientoId) });
          }
          await updateDoc(docViajeIdaRef, { [`tempSelecciones.${asientoId}`]: null });
          alert(conReembolso
            ? `✅ Asiento liberado. Reembolso de $${montoFinal} registrado.`
            : "✅ Asiento liberado. Sin reembolso registrado.");
          setSeleccionadosIda([]); setTipoDetalle(null); setModo('VENTA');
          setModoLiberacion(null); setMontoReembolso(''); setMotivoLiberacion(''); setTipoReembolso('total');
        } catch (error) {
          console.error(error);
          alert("Error liberando asiento: " + error.message);
        }
      }

      if (modo === 'DETALLE' && tipoDetalle === 'bloqueado') {
        const asientoId = seleccionadosIda[0];
        const objBloqueado = fullBloqueadosIda.find(b => (typeof b === 'object' ? b.asiento : b) === asientoId);
        try {
          if (objBloqueado) {
            await updateDoc(docViajeIdaRef, { bloqueados: arrayRemove(objBloqueado) });
          } else {
            await updateDoc(docViajeIdaRef, { bloqueados: arrayRemove(asientoId) });
          }
          await updateDoc(docViajeIdaRef, { [`tempSelecciones.${asientoId}`]: null });
          alert("🔓 Asiento desbloqueado.");
          setSeleccionadosIda([]); setTipoDetalle(null); setModo('VENTA');
        } catch (error) {
          console.error(error);
          alert("Error desbloqueando: " + error.message);
        }
      }

    } catch (error) { console.error(error); alert("Error: " + error.message); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (!ticketsGenerados || ticketsGenerados.length === 0) { setQrDataUrls({}); return; }
    const mapa = {};
    ticketsGenerados.forEach(tk => {
      mapa[tk.idRef] = getQrUrl(tk.idRef);
    });
    setQrDataUrls(mapa);
  }, [ticketsGenerados]);

  const cerrarTicketExito = () => {
    setTicketsGenerados(null); setSeleccionadosIda([]); setSeleccionadosRegreso([]);
    setNombresPax({}); setTelefonoPax(""); setMotivoBloqueo("");
    setFechaRegreso(""); setRegresoSeleccionado(""); setModo("VENTA"); setMapaVista('IDA');
    setTipoDetalle(null);
    setCanalVenta('taquilla'); setCanalVentaOtro(''); setAtendidoPor('');
    setModoLiberacion(null); setMontoReembolso(''); setMotivoLiberacion(''); setTipoReembolso('total');
  };

  const handleCerrar = () => {
    limpiarTodosTemps();
    onClose();
  };

  // ─── GENERAR PDF ─────────────────────────────────────────────────────────
  const generarPDF = async () => {
    if (!ticketsGenerados || ticketsGenerados.length === 0) return;

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [80, 220] });
    const anchoTicket = 80;

    for (let idx = 0; idx < ticketsGenerados.length; idx++) {
      const ticket = ticketsGenerados[idx];
      if (idx > 0) pdf.addPage([80, 220]);

      const esRedondo = ticket.tipoViaje === 'redondo';
      let y = 8;

      pdf.setFillColor(15, 23, 42);
      pdf.rect(0, 0, anchoTicket, 26, 'F');
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text('TRANSPORTES ANGELES DEL PUERTO', anchoTicket / 2, y + 2, { align: 'center' });
      pdf.setFontSize(6.5);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Boleto de viaje oficial', anchoTicket / 2, y + 8, { align: 'center' });
      pdf.setFontSize(5.5);
      pdf.setTextColor(148, 163, 184);
      pdf.text('Conserve este documento. Constituye el comprobante', anchoTicket / 2, y + 14, { align: 'center' });
      pdf.text('oficial de su reservacion y pago de viaje.', anchoTicket / 2, y + 18, { align: 'center' });
      y = 30;

      const badgeColor = esRedondo ? [126, 34, 206] : [5, 150, 105];
      pdf.setFillColor(...badgeColor);
      pdf.roundedRect(anchoTicket / 2 - 18, y - 1, 36, 7, 2, 2, 'F');
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'bold');
      pdf.text(esRedondo ? 'BOLETO REDONDO' : 'BOLETO SENCILLO', anchoTicket / 2, y + 4, { align: 'center' });
      y += 11;

      pdf.setDrawColor(229, 231, 235);
      pdf.setLineWidth(0.3);
      pdf.line(5, y, anchoTicket - 5, y);
      y += 5;

      pdf.setTextColor(100, 116, 139);
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'normal');
      pdf.text('RUTA DE IDA', 5, y);
      y += 4;
      pdf.setTextColor(15, 23, 42);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`${viaje.origen}`, 5, y, { maxWidth: anchoTicket - 10 });
      y += 4;
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(100, 116, 139);
      pdf.text(`>  ${viaje.destino}`, 5, y, { maxWidth: anchoTicket - 10 });
      y += 7;

      pdf.setFillColor(248, 250, 252);
      pdf.roundedRect(4, y - 2, anchoTicket - 8, 20, 2, 2, 'F');
      const col1x = 6;
      const col2x = anchoTicket / 2 + 2;

      const renderCampo = (label, valor, x, yPos) => {
        pdf.setFontSize(5.5);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(148, 163, 184);
        pdf.text(label, x, yPos);
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(15, 23, 42);
        pdf.text(String(valor), x, yPos + 4.5);
      };

      renderCampo('FECHA', viaje.fecha, col1x, y + 1);
      renderCampo('HORA', viaje.hora, col2x, y + 1);
      renderCampo('ASIENTO', `No. ${ticket.asiento.replace('a', '')}`, col1x, y + 10);
      renderCampo('PRECIO', `$${ticket.precio}`, col2x, y + 10);
      y += 24;

      if (esRedondo && ticket.fechaRegreso) {
        pdf.setDrawColor(229, 231, 235);
        pdf.line(5, y, anchoTicket - 5, y);
        y += 5;
        pdf.setTextColor(126, 34, 206);
        pdf.setFontSize(6);
        pdf.setFont('helvetica', 'bold');
        pdf.text('REGRESO', 5, y);
        y += 4;
        pdf.setFontSize(7.5);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(15, 23, 42);
        pdf.text(`${viaje.destino}`, 5, y, { maxWidth: anchoTicket - 10 });
        y += 4;
        pdf.setFontSize(6.5);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(100, 116, 139);
        pdf.text(`>  ${viaje.origen}`, 5, y, { maxWidth: anchoTicket - 10 });
        y += 6;
        pdf.setFillColor(250, 245, 255);
        pdf.roundedRect(4, y - 2, anchoTicket - 8, ticket.asientoRegreso ? 16 : 12, 2, 2, 'F');
        renderCampo('FECHA REGRESO', ticket.fechaRegreso, col1x, y + 1);
        renderCampo('HORA', ticket.horaRegreso || '—', col2x, y + 1);
        if (ticket.asientoRegreso) {
          renderCampo('ASIENTO REGRESO', `No. ${ticket.asientoRegreso.replace('a', '')}`, col1x, y + 9);
        }
        y += ticket.asientoRegreso ? 20 : 16;
      }

      pdf.setDrawColor(229, 231, 235);
      pdf.line(5, y, anchoTicket - 5, y);
      y += 5;

      pdf.setTextColor(100, 116, 139);
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'normal');
      pdf.text('PASAJERO', 5, y);
      y += 4;
      pdf.setTextColor(15, 23, 42);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text(ticket.nombre || '—', 5, y, { maxWidth: anchoTicket - 10 });
      y += 5;
      if (ticket.telefono) {
        pdf.setTextColor(100, 116, 139);
        pdf.setFontSize(6);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`Tel: ${ticket.telefono}`, 5, y);
        y += 5;
      }

      pdf.setDrawColor(229, 231, 235);
      pdf.setLineWidth(0.3);
      pdf.line(5, y, anchoTicket - 5, y);
      y += 4;

      const qrUrl = qrDataUrls[ticket.idRef];
      const qrSize = 30;
      const qrX = anchoTicket / 2 - qrSize / 2;

      if (qrUrl) {
        try {
          const resp = await fetch(qrUrl);
          const blob = await resp.blob();
          const b64 = await new Promise(res => {
            const reader = new FileReader();
            reader.onloadend = () => res(reader.result);
            reader.readAsDataURL(blob);
          });
          pdf.setFillColor(255, 255, 255);
          pdf.setDrawColor(229, 231, 235);
          pdf.roundedRect(qrX - 2, y - 2, qrSize + 4, qrSize + 9, 2, 2, 'FD');
          pdf.addImage(b64, 'PNG', qrX, y, qrSize, qrSize);
          pdf.setTextColor(100, 116, 139);
          pdf.setFontSize(5.5);
          pdf.setFont('helvetica', 'normal');
          pdf.text('Escanear para validar', anchoTicket / 2, y + qrSize + 4, { align: 'center' });
          y += qrSize + 12;
        } catch (e) {
          console.warn('No se pudo cargar QR para PDF:', e);
          y += 4;
        }
      } else {
        y += 4;
      }

      pdf.setFillColor(241, 245, 249);
      pdf.roundedRect(4, y - 2, anchoTicket - 8, 12, 2, 2, 'F');
      pdf.setTextColor(100, 116, 139);
      pdf.setFontSize(5.5);
      pdf.setFont('helvetica', 'normal');
      pdf.text('FOLIO', anchoTicket / 2, y + 1, { align: 'center' });
      pdf.setTextColor(15, 23, 42);
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`# ${ticket.idRef}`, anchoTicket / 2, y + 7, { align: 'center' });
      y += 15;

      pdf.setDrawColor(156, 163, 175);
      pdf.setLineWidth(0.2);
      pdf.setLineDashPattern([1, 1.5], 0);
      pdf.line(5, y, anchoTicket - 5, y);
      pdf.setLineDashPattern([], 0);
      pdf.setFontSize(5);
      pdf.setTextColor(156, 163, 175);
      pdf.text('cortar aqui', anchoTicket / 2, y + 3, { align: 'center' });
      y += 8;

      pdf.setFillColor(15, 23, 42);
      pdf.rect(0, y, anchoTicket, 14, 'F');
      pdf.setTextColor(148, 163, 184);
      pdf.setFontSize(5.5);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Boleto personal e intransferible. Sin reembolso.', anchoTicket / 2, y + 4, { align: 'center' });
      pdf.text('Presentelo al abordar. 15 min antes de salida.', anchoTicket / 2, y + 8, { align: 'center' });
      pdf.setTextColor(100, 116, 139);
      pdf.text(`Emitido: ${new Date().toLocaleString('es-MX')}`, anchoTicket / 2, y + 12, { align: 'center' });

      pdf.addPage([80, 220]);
      let ty = 0;

      pdf.setFillColor(29, 78, 216);
      pdf.rect(0, 0, anchoTicket, 16, 'F');
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(8);
      pdf.setFont('helvetica', 'bold');
      pdf.text('TERMINOS Y CONDICIONES', anchoTicket / 2, 7, { align: 'center' });
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Angele del Puerto — Reverso del boleto', anchoTicket / 2, 13, { align: 'center' });
      ty = 21;

      pdf.setFillColor(239, 246, 255);
      pdf.setDrawColor(191, 219, 254);
      pdf.setLineWidth(0.3);
      pdf.roundedRect(4, ty, anchoTicket - 8, 18, 2, 2, 'FD');
      pdf.setTextColor(29, 78, 216);
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'bold');
      pdf.text('PUNTO DE ABORDAJE', 8, ty + 5);
      pdf.setTextColor(15, 23, 42);
      pdf.setFontSize(6.5);
      pdf.setFont('helvetica', 'bold');
      pdf.text('Terminal Centro (PLAZA 522)', 8, ty + 10);
      pdf.setFontSize(5.5);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(71, 85, 105);
      pdf.text('Galeana 522, Centro, 68000 Oaxaca de Juarez, Oax.', 8, ty + 15, { maxWidth: anchoTicket - 16 });
      ty += 22;

      const seccion = (titulo, lineasTexto) => {
        pdf.setTextColor(15, 23, 42);
        pdf.setFontSize(6);
        pdf.setFont('helvetica', 'bold');
        pdf.text(titulo, 5, ty);
        ty += 4;
        pdf.setFontSize(5.5);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(71, 85, 105);
        lineasTexto.forEach(linea => {
          const wrapped = pdf.splitTextToSize(linea, anchoTicket - 10);
          pdf.text(wrapped, 5, ty);
          ty += wrapped.length * 3.5;
        });
        ty += 2;
      };

      seccion('ABORDAJE Y VALIDEZ', [
        'El boleto es personal e intransferible. Valido solo para la fecha y hora marcada.',
        'Presentarse 15 minutos antes de la salida.',
        'Obligatorio presentar identificacion oficial vigente al abordar.',
        'Viaje con tranquilidad. Su boleto lo protege con seguro de viajero contra accidentes desde el momento en que aborda hasta llegar a su destino.',
      ]);

      seccion('POLITICA DE EQUIPAJE', [
        'Derecho a transportar equipaje de uso personal.',
        'El exceso o mercancia generara costo extra.',
        'La empresa no se hace responsable por objetos de valor no reportados.',
      ]);

      seccion('CAMBIOS Y CANCELACIONES', [
        'NO HAY REEMBOLSOS para compras en taquilla.',
        'Solo se permiten cambios de fecha con al menos 2 horas y media de anticipacion, sujeto a disponibilidad y cargo del 10%.',
      ]);

      pdf.setFillColor(254, 242, 242);
      pdf.setDrawColor(254, 202, 202);
      pdf.roundedRect(4, ty, anchoTicket - 8, 12, 2, 2, 'FD');
      pdf.setTextColor(185, 28, 28);
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'bold');
      pdf.text('PROHIBIDO: ARMAS Y ALCOHOL', anchoTicket / 2, ty + 5, { align: 'center' });
      pdf.setFontSize(5.5);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Nos reservamos el derecho de admision a personas', anchoTicket / 2, ty + 9, { align: 'center' });
      ty += 16;

      pdf.setDrawColor(226, 232, 240);
      pdf.setLineWidth(0.2);
      pdf.line(5, ty, anchoTicket - 5, ty);
      ty += 4;
      pdf.setTextColor(148, 163, 184);
      pdf.setFontSize(5.5);
      pdf.setFont('helvetica', 'normal');
      pdf.text('Sugerencias y quejas: 954 167 7156', anchoTicket / 2, ty, { align: 'center' });
      ty += 4;
      pdf.text('www.transportesangelesdelpuerto.mx', anchoTicket / 2, ty, { align: 'center' });
    }

    pdf.save(`boleto_${ticketsGenerados[0]?.idRef || 'ticket'}.pdf`);
  };

  // ─── ENVIAR WHATSAPP ──────────────────────────────────────────────────────
  const enviarWhatsApp = () => {
    if (!ticketsGenerados || ticketsGenerados.length === 0) return;

    const t = ticketsGenerados[0];
    const esRedondo = t.tipoViaje === 'redondo';
    const telefono = t.telefono ? t.telefono.replace(/\D/g, '') : '';
    const nombreTitular = t.nombre || 'pasajero';

    const fechaIda = t.fechaViaje || viaje.fecha || '—';
    const horaIda = t.horaViaje || viaje.hora || '—';
    const origenIda = t.origen || viaje.origen || '—';
    const destIda = t.destino || viaje.destino || '—';

    const BASE_URL = 'https://transportesangelesdelpuerto.mx/boleto';

    const lineas = [
      `🚌 *¡Hola ${nombreTitular}!*`,
      `Gracias por viajar con Ángeles del Puerto 🙌`,
      ``,
      `Aquí ${ticketsGenerados.length > 1 ? 'están tus boletos digitales 🎟️' : 'está tu boleto digital 🎟️'}:`,
    ];

    ticketsGenerados.forEach(tk => {
      lineas.push(`👉 ${BASE_URL}/${tk.idRef}`);
    });

    lineas.push(``, `📋 *Resumen del viaje:*`, `*──── IDA ────*`);
    lineas.push(`🛫 *Origen:* ${origenIda}`);
    lineas.push(`🛬 *Destino:* ${destIda}`);
    lineas.push(`📅 *Fecha:* ${fechaIda}`);
    lineas.push(`⏰ *Hora:* ${horaIda}`);

    ticketsGenerados.forEach((tk, i) => {
      const numAsiento = tk.asiento ? tk.asiento.replace('a', '') : '—';
      lineas.push(`💺 *Asiento ${i + 1}:* No. ${numAsiento} — ${tk.nombre}`);
    });

    if (esRedondo && t.fechaRegreso) {
      lineas.push(``, `*──── REGRESO ────*`);
      lineas.push(`🛫 *Origen:* ${destIda}`);
      lineas.push(`🛬 *Destino:* ${origenIda}`);
      lineas.push(`📅 *Fecha:* ${t.fechaRegreso}`);
      lineas.push(`⏰ *Hora:* ${t.horaRegreso || '—'}`);
      ticketsGenerados.forEach((tk, i) => {
        if (tk.asientoRegreso) {
          lineas.push(`💺 *Asiento regreso ${i + 1}:* No. ${tk.asientoRegreso.replace('a', '')} — ${tk.nombre}`);
        }
      });
    }

    lineas.push(``, `💵 *Total pagado:* $${ticketsGenerados.reduce((s, tk) => s + (tk.precio || 0), 0)}`);
    lineas.push(`💳 *Método:* Efectivo en taquilla`, ``);
    lineas.push(`📲 *En el link puedes ver y descargar tu QR de abordaje.*`);
    lineas.push(`_Preséntalo al conductor al subir al camión._`, ``);
    lineas.push(`_Sin reembolso. Preséntate 15 min antes de tu salida._ 🙏`);

    const mensaje = lineas.join('\n');
    const numeroDestino = telefono.length >= 10 ? `52${telefono}` : '';
    const url = `https://wa.me/${numeroDestino}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const totalACobrar = seleccionadosIda.length * (modo === 'REDONDO' ? precioRedondoDB : viaje.precio);
  const isMapaIda = mapaVista === 'IDA';
  const ocupadosRender = isMapaIda ? listaOcupadosIda : listaOcupadosRegreso;
  const bloqueadosRender = isMapaIda ? listaBloqueadosIda : listaBloqueadosRegreso;
  const seleccionadosRender = isMapaIda ? seleccionadosIda : seleccionadosRegreso;
  const tempActuales = isMapaIda ? tempSeleccionesIda : tempSeleccionesRegreso;

  const sesionesOnline = new Set(
    Object.values(tempActuales)
      .filter(v => v && !v.esTaquilla && v.sessionId !== SESSION_ID && v.expiresAt && new Date(v.expiresAt) > Date.now())
      .map(v => v.sessionId)
  ).size;

  const asientoDetalle = modo === 'DETALLE' && seleccionadosIda[0];
  const objOcupadoDetalle = asientoDetalle
    ? fullOcupadosIda.find(o => (typeof o === 'object' ? o.asiento : o) === asientoDetalle)
    : null;
  const objBloqueadoDetalle = asientoDetalle
    ? fullBloqueadosIda.find(b => (typeof b === 'object' ? b.asiento : b) === asientoDetalle)
    : null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-2 sm:p-4 backdrop-blur-sm">
      <div className="bg-white w-full max-w-3xl rounded-xl shadow-2xl flex flex-col md:flex-row h-[85vh] md:h-[580px] relative overflow-hidden">
        <button onClick={handleCerrar} className="absolute top-2 right-2 text-gray-500 hover:text-white hover:bg-red-500 text-lg font-bold z-50 bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition-all">✕</button>

        {/* LADO IZQUIERDO: MAPA */}
        {!ticketsGenerados && (
          <div className="w-full md:w-[45%] bg-slate-50 p-3 flex flex-col items-center justify-start border-b md:border-b-0 md:border-r border-slate-200 overflow-y-auto">
            {modo === 'REDONDO' && regresoSeleccionado ? (
              <div className="flex w-full bg-gray-200 rounded-lg p-1 mb-3">
                <button onClick={() => setMapaVista('IDA')} className={`flex-1 py-1 text-xs font-bold rounded-md transition-colors ${isMapaIda ? 'bg-white shadow text-blue-600' : 'text-gray-500'}`}>1. IDA</button>
                <button onClick={() => setMapaVista('REGRESO')} className={`flex-1 py-1 text-xs font-bold rounded-md transition-colors ${!isMapaIda ? 'bg-white shadow text-purple-600' : 'text-gray-500'}`}>2. REGRESO</button>
              </div>
            ) : (
              <div className="text-center mb-3 pt-2">
                <h3 className="text-sm font-bold text-slate-800"><FaBus className="inline text-blue-500 mb-1" /> Mapa de Asientos (IDA)</h3>
                <p className="text-[10px] text-slate-500">{viaje.origen} ➝ {viaje.destino} • {viaje.hora}</p>
              </div>
            )}

            {sesionesOnline > 0 && (
              <div className="w-full mb-2 px-2 py-1.5 bg-orange-50 border border-orange-200 rounded-lg text-center">
                <p className="text-[10px] font-bold text-orange-600 animate-pulse">
                  👀 {sesionesOnline} cliente{sesionesOnline > 1 ? 's' : ''} online {sesionesOnline > 1 ? 'están eligiendo' : 'está eligiendo'} asientos
                </p>
              </div>
            )}

            <div className="flex flex-wrap justify-center gap-2 mb-2 text-[9px] font-bold text-gray-400">
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-white border border-emerald-500 inline-block"></span>Libre</span>
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-blue-600 inline-block"></span>Tuyo</span>
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-orange-400 inline-block"></span>Online</span>
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-yellow-400 inline-block"></span>Taquilla</span>
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-slate-800 inline-block"></span>Vendido</span>
              <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-500 inline-block"></span>Bloqueado</span>
            </div>

            <div className="relative border-2 border-slate-800 rounded-[20px] p-3 pb-5 bg-white shadow-md transform scale-90 sm:scale-100">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-1.5 bg-slate-800 rounded-b-md z-10"></div>
              <div className="grid gap-y-1.5 mt-3">
                {SEAT_MAP.map((fila, i) => (
                  <div key={i} className="flex justify-between items-center h-8 gap-1.5">
                    {fila.map((asiento, j) => {
                      if (asiento === 'p') return <div key={j} className="w-8"></div>;
                      if (asiento === 'conductor') return <div key={j} className="w-8 h-8 flex items-center justify-center text-slate-300 bg-slate-50 rounded-md text-xs">☸️</div>;
                      if (asiento === 'puerta') return <div key={j} className="w-8 flex items-center justify-center"><span className="text-[7px] font-black text-slate-300 uppercase -rotate-90">Entrada</span></div>;

                      const isOcupado = ocupadosRender.includes(asiento);
                      const isBloqueado = bloqueadosRender.includes(asiento);
                      const isSelected = seleccionadosRender.includes(asiento);

                      const tempData = tempActuales[asiento];
                      const esOtrasTaquilla = tempData && tempData.esTaquilla && tempData.sessionId !== SESSION_ID;
                      const esOnline = tempData && !tempData.esTaquilla && tempData.sessionId !== SESSION_ID &&
                        tempData.expiresAt && new Date(tempData.expiresAt) > Date.now();

                      // ── NUEVO: resaltado desde notificación ──────────────
                      const estaResaltado = resaltando.includes(asiento);

                      let btnClass = 'bg-white border text-emerald-600 border-emerald-500 hover:bg-emerald-50';
                      if (isOcupado) btnClass = 'bg-slate-800 text-white border-slate-800 cursor-pointer';
                      if (isBloqueado) btnClass = 'bg-red-500 text-white border-red-500 cursor-pointer';
                      if (esOnline) btnClass = 'bg-orange-400 text-white border-orange-400 cursor-not-allowed animate-pulse';
                      if (esOtrasTaquilla) btnClass = 'bg-yellow-400 text-white border-yellow-400 cursor-not-allowed';
                      if (isSelected && modo === 'DETALLE') btnClass = isOcupado
                        ? 'bg-slate-600 text-white border-slate-600 ring-2 ring-slate-300 scale-110 z-10'
                        : 'bg-red-400 text-white border-red-400 ring-2 ring-red-200 scale-110 z-10';
                      else if (isSelected) btnClass = `text-white ring-2 scale-110 z-10 ${isMapaIda ? 'bg-blue-600 border-blue-600 ring-blue-200' : 'bg-purple-600 border-purple-600 ring-purple-200'}`;

                      return (
                        <div key={asiento} className="relative">
                          {esOnline && <AsientoTimer expiresAt={tempData.expiresAt} />}
                          {esOtrasTaquilla && (
                            <span className="absolute -top-1.5 -right-1.5 bg-yellow-500 text-white text-[7px] font-black rounded-full w-3.5 h-3.5 flex items-center justify-center z-20">T</span>
                          )}
                          <button
                            onClick={() => toggleAsiento(asiento)}
                            disabled={esOnline}
                            title={
                              esOnline ? `⏳ Cliente online eligiendo` :
                                esOtrasTaquilla ? `Seleccionado por otro taquillero` :
                                  isOcupado ? 'Vendido — clic para gestionar' :
                                    isBloqueado ? 'Bloqueado — clic para desbloquear' :
                                      isSelected ? 'Clic para deseleccionar' : 'Disponible'
                            }
                            className={`w-8 h-8 rounded-md flex items-center justify-center font-black text-[10px] transition-all shadow-sm ${btnClass} ${estaResaltado ? 'ring-4 ring-yellow-400 animate-pulse' : ''}`}
                          >
                            {estaResaltado ? '⭐' : isOcupado ? 'X' : isBloqueado ? '🔒' : esOnline ? '⏳' : esOtrasTaquilla ? 'T' : asiento.replace('a', '')}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-3 text-[10px] font-bold text-gray-400">
              Seleccionados: {seleccionadosRender.length} {modo === 'REDONDO' && !isMapaIda && `de ${seleccionadosIda.length}`}
            </div>
          </div>
        )}

        {/* PANTALLA DE ÉXITO */}
        {ticketsGenerados && (
          <div className="w-full bg-white flex flex-col h-full overflow-y-auto">
            <div className="bg-emerald-500 px-5 py-4 text-white text-center shrink-0">
              <FaCheckCircle className="text-3xl mx-auto mb-1" />
              <h2 className="text-lg font-black">¡Venta Exitosa!</h2>
              <p className="text-xs text-emerald-100">{ticketsGenerados.length} boleto(s) generado(s)</p>
            </div>

            <div className="flex-1 px-4 py-3 space-y-3 overflow-y-auto">
              {ticketsGenerados.map((ticket, idx) => {
                const esRedondo = ticket.tipoViaje === 'redondo';
                return (
                  <div key={ticket.idRef} className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                    <div className={`px-3 py-2 flex justify-between items-center ${esRedondo ? 'bg-purple-600' : 'bg-slate-800'}`}>
                      <span className="text-white text-xs font-black">
                        {esRedondo ? '⮂ REDONDO' : '→ SENCILLO'} · Asiento {ticket.asiento.replace('a', '')}
                      </span>
                      <span className="bg-white/20 text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
                        #{ticket.idRef}
                      </span>
                    </div>

                    <div className="p-3 space-y-2 bg-gray-50">
                      <div>
                        <p className="text-[9px] text-gray-400 font-bold uppercase">Pasajero</p>
                        <p className="text-sm font-black text-gray-800">{ticket.nombre}</p>
                        {ticket.telefono && <p className="text-[10px] text-gray-500">📱 {ticket.telefono}</p>}
                      </div>

                      <div className="bg-white rounded-lg p-2 border border-gray-100">
                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">✈ IDA</p>
                        <div className="grid grid-cols-2 gap-1 text-[10px]">
                          <div><span className="text-gray-400">Origen:</span> <span className="font-bold text-gray-700">{viaje.origen}</span></div>
                          <div><span className="text-gray-400">Destino:</span> <span className="font-bold text-gray-700">{viaje.destino}</span></div>
                          <div><span className="text-gray-400">Fecha:</span> <span className="font-bold text-gray-700">{viaje.fecha}</span></div>
                          <div><span className="text-gray-400">Hora:</span> <span className="font-bold text-gray-700">{viaje.hora}</span></div>
                        </div>
                      </div>

                      {esRedondo && ticket.fechaRegreso && (
                        <div className="bg-purple-50 rounded-lg p-2 border border-purple-100">
                          <p className="text-[9px] font-bold text-purple-500 uppercase mb-1">⮂ REGRESO</p>
                          <div className="grid grid-cols-2 gap-1 text-[10px]">
                            <div><span className="text-gray-400">Origen:</span> <span className="font-bold text-gray-700">{viaje.destino}</span></div>
                            <div><span className="text-gray-400">Destino:</span> <span className="font-bold text-gray-700">{viaje.origen}</span></div>
                            <div><span className="text-gray-400">Fecha:</span> <span className="font-bold text-gray-700">{ticket.fechaRegreso}</span></div>
                            <div><span className="text-gray-400">Hora:</span> <span className="font-bold text-gray-700">{ticket.horaRegreso || '—'}</span></div>
                            {ticket.asientoRegreso && <div><span className="text-gray-400">Asiento:</span> <span className="font-bold text-purple-700">No. {ticket.asientoRegreso.replace('a', '')}</span></div>}
                          </div>
                        </div>
                      )}

                      <div className="flex justify-between items-center pt-1 border-t border-gray-100">
                        <span className="text-[10px] text-gray-400 font-bold">TOTAL COBRADO</span>
                        <span className="text-base font-black text-emerald-600">${ticket.precio}</span>
                      </div>

                      {qrDataUrls[ticket.idRef] ? (
                        <div className="flex flex-col items-center pt-2 border-t border-gray-100">
                          <p className="text-[9px] text-gray-400 font-bold uppercase mb-1">📷 QR de validación</p>
                          <div className="bg-white p-1.5 rounded-lg border border-gray-200 shadow-sm">
                            <img src={qrDataUrls[ticket.idRef]} alt={`QR boleto ${ticket.idRef}`} className="w-24 h-24" />
                          </div>
                          <p className="text-[8px] text-gray-400 mt-1">Folio: <span className="font-bold text-gray-600">{ticket.idRef}</span></p>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center pt-2 border-t border-gray-100">
                          <span className="text-[9px] text-gray-300 animate-pulse">Generando QR...</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="shrink-0 px-4 pb-4 pt-2 border-t border-gray-100 space-y-2 bg-white">
              <div className="grid grid-cols-2 gap-2">
                <button onClick={generarPDF} className="flex items-center justify-center gap-2 py-2.5 bg-red-500 hover:bg-red-600 text-white rounded-lg font-bold text-sm transition-colors shadow-sm">
                  <FaFilePdf /> Imprimir PDF
                </button>
                <button onClick={enviarWhatsApp} className="flex items-center justify-center gap-2 py-2.5 bg-green-500 hover:bg-green-600 text-white rounded-lg font-bold text-sm transition-colors shadow-sm">
                  <FaWhatsapp /> WhatsApp
                </button>
              </div>
              <button onClick={cerrarTicketExito} className="w-full py-2 text-blue-600 font-bold text-sm bg-blue-50 hover:bg-blue-100 transition-colors rounded-lg">
                + Vender otro viaje
              </button>
            </div>
          </div>
        )}

        {/* LADO DERECHO: FORMULARIO */}
        {!ticketsGenerados && (
          <div className="w-full md:w-[55%] p-4 bg-white flex flex-col h-full overflow-y-auto pt-10 md:pt-4">
            <div className="flex bg-gray-100 rounded-lg p-1 gap-1 mb-3 shrink-0">
              <button onClick={() => { setModo('VENTA'); setTipoDetalle(null); setSeleccionadosIda([]); }} className={`flex-1 py-1.5 text-[10px] font-bold rounded text-center ${modo === 'VENTA' ? 'bg-white shadow text-emerald-600' : 'text-gray-400'}`}><FaTicketAlt className="inline mb-0.5" /> SENCILLO</button>
              <button onClick={() => { setModo('REDONDO'); setTipoDetalle(null); setSeleccionadosIda([]); }} className={`flex-1 py-1.5 text-[10px] font-bold rounded text-center ${modo === 'REDONDO' ? 'bg-white shadow text-purple-600' : 'text-gray-400'}`}><FaSyncAlt className="inline mb-0.5" /> REDONDO</button>
              <button onClick={() => { setModo('BLOQUEO'); setTipoDetalle(null); setSeleccionadosIda([]); }} className={`flex-1 py-1.5 text-[10px] font-bold rounded text-center ${modo === 'BLOQUEO' ? 'bg-white shadow text-red-500' : 'text-gray-400'}`}><FaBan className="inline mb-0.5" /> BLOQUEAR</button>
            </div>

            {seleccionadosIda.length === 0 && modo !== 'DETALLE' && (
              <div className="flex-1 flex flex-col items-center justify-center text-gray-300">
                <span className="text-2xl mb-1">👈</span>
                <p className="text-xs font-medium text-center">
                  {modo === 'BLOQUEO' ? 'Toca asientos para bloquear' : 'Toca asientos en el mapa de IDA'}
                </p>
              </div>
            )}

            {modo === 'DETALLE' && tipoDetalle === 'vendido' && (
              <div className="flex-1 flex flex-col gap-3 px-2 overflow-y-auto pt-2">
                {/* Info del asiento */}
                <div className="w-full bg-slate-50 rounded-xl border border-slate-200 p-4">
                  <p className="text-xs font-black text-slate-700 mb-1">
                    🎟️ Asiento {seleccionadosIda[0]?.replace('a', '')} — Vendido
                  </p>
                  {objOcupadoDetalle && typeof objOcupadoDetalle === 'object' && (
                    <div className="text-[10px] text-slate-500 space-y-0.5 mt-2">
                      <p><span className="font-bold">Pasajero:</span> {objOcupadoDetalle.nombre || '—'}</p>
                      <p><span className="font-bold">Teléfono:</span> {objOcupadoDetalle.telefono || '—'}</p>
                      <p><span className="font-bold">Ticket:</span> {objOcupadoDetalle.ticketId || '—'}</p>
                      <p><span className="font-bold">Pago:</span> {objOcupadoDetalle.tipoPago || '—'}</p>
                    </div>
                  )}
                </div>

                {/* Seleccionar tipo de liberación */}
                {!modoLiberacion && (
                  <div className="space-y-2">
                    <p className="text-[10px] font-bold text-gray-500 uppercase text-center">¿Cómo se libera este asiento?</p>
                    <button
                      onClick={() => setModoLiberacion('sin')}
                      className="w-full py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-bold text-xs transition-colors"
                    >
                      🔓 Sin reembolso — Cliente no llegó
                    </button>
                    <button
                      onClick={() => setModoLiberacion('con')}
                      className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-xs transition-colors"
                    >
                      💵 Con reembolso — Devolver dinero
                    </button>
                    <button
                      onClick={() => { setSeleccionadosIda([]); setTipoDetalle(null); setModo('VENTA'); }}
                      className="w-full text-xs text-gray-400 hover:text-gray-600"
                    >
                      Cancelar
                    </button>
                  </div>
                )}

                {/* Formulario sin reembolso */}
                {modoLiberacion === 'sin' && (
                  <div className="space-y-2">
                    <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
                      <p className="text-[10px] text-orange-700 font-bold mb-1">🔓 Liberación sin reembolso</p>
                      <p className="text-[9px] text-orange-600">El ingreso se conserva en reportes. Solo se libera el asiento.</p>
                    </div>
                    <div>
                      <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">Motivo</label>
                      <select className="w-full p-1.5 border rounded text-xs outline-none focus:border-orange-400" value={motivoLiberacion} onChange={e => setMotivoLiberacion(e.target.value)}>
                        <option value="">Seleccionar...</option>
                        <option value="Cliente no se presentó">🚫 Cliente no se presentó</option>
                        <option value="Cliente canceló tarde">⏰ Cliente canceló tarde</option>
                        <option value="Error de taquilla - sin reembolso">⚠️ Error de taquilla</option>
                        <option value="otro">✏️ Otro</option>
                      </select>
                      {motivoLiberacion === 'otro' && (
                        <input type="text" className="w-full p-1.5 border rounded text-xs mt-1 outline-none" placeholder="Describe el motivo..." onChange={e => setMotivoLiberacion(e.target.value)} />
                      )}
                    </div>
                    <div>
                      <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">¿Quién autoriza?</label>
                      <input type="text" className="w-full p-1.5 border rounded text-xs outline-none focus:border-orange-400" placeholder="Nombre del encargado" value={atendidoPor} onChange={e => setAtendidoPor(e.target.value)} />
                    </div>
                    <button onClick={ejecutarAccion} disabled={loading} className="w-full py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-bold text-sm transition-colors">
                      {loading ? '...' : '🔓 Confirmar liberación sin reembolso'}
                    </button>
                    <button onClick={() => setModoLiberacion(null)} className="w-full text-xs text-gray-400 hover:text-gray-600">← Volver</button>
                  </div>
                )}

                {/* Formulario con reembolso */}
                {modoLiberacion === 'con' && (
                  <div className="space-y-2">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                      <p className="text-[10px] text-blue-700 font-bold mb-1">💵 Liberación con reembolso</p>
                      <p className="text-[9px] text-blue-600">El reembolso se descontará del total en reportes para cuadrar la caja.</p>
                    </div>
                    <div>
                      <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">Tipo de reembolso</label>
                      <div className="flex gap-2">
                        <button onClick={() => setTipoReembolso('total')} className={`flex-1 py-1.5 rounded text-xs font-bold border transition-colors ${tipoReembolso === 'total' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300'}`}>
                          Total
                        </button>
                        <button onClick={() => setTipoReembolso('parcial')} className={`flex-1 py-1.5 rounded text-xs font-bold border transition-colors ${tipoReembolso === 'parcial' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300'}`}>
                          Parcial
                        </button>
                      </div>
                    </div>
                    {tipoReembolso === 'parcial' && (
                      <div>
                        <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">Monto a reembolsar ($)</label>
                        <input type="number" min="0" className="w-full p-1.5 border rounded text-xs outline-none focus:border-blue-400" placeholder="0.00" value={montoReembolso} onChange={e => setMontoReembolso(e.target.value)} />
                      </div>
                    )}
                    <div>
                      <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">Motivo</label>
                      <select className="w-full p-1.5 border rounded text-xs outline-none focus:border-blue-400" value={motivoLiberacion} onChange={e => setMotivoLiberacion(e.target.value)}>
                        <option value="">Seleccionar...</option>
                        <option value="Cliente canceló a tiempo">✅ Cliente canceló a tiempo</option>
                        <option value="Error de taquilla">⚠️ Error de taquilla</option>
                        <option value="Problema con el servicio">🚌 Problema con el servicio</option>
                        <option value="otro">✏️ Otro</option>
                      </select>
                      {motivoLiberacion === 'otro' && (
                        <input type="text" className="w-full p-1.5 border rounded text-xs mt-1 outline-none" placeholder="Describe el motivo..." onChange={e => setMotivoLiberacion(e.target.value)} />
                      )}
                    </div>
                    <div>
                      <label className="text-[9px] font-bold text-gray-500 uppercase block mb-1">¿Quién autoriza el reembolso?</label>
                      <input type="text" className="w-full p-1.5 border rounded text-xs outline-none focus:border-blue-400" placeholder="Nombre del encargado" value={atendidoPor} onChange={e => setAtendidoPor(e.target.value)} />
                    </div>
                    <button onClick={ejecutarAccion} disabled={loading} className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-sm transition-colors">
                      {loading ? '...' : `💵 Confirmar reembolso ${tipoReembolso === 'total' ? 'total' : `$${montoReembolso || '0'}`}`}
                    </button>
                    <button onClick={() => setModoLiberacion(null)} className="w-full text-xs text-gray-400 hover:text-gray-600">← Volver</button>
                  </div>
                )}
              </div>
            )}

            {modo === 'DETALLE' && tipoDetalle === 'bloqueado' && (
              <div className="flex-1 flex flex-col items-center justify-center gap-3 px-2">
                <div className="w-full bg-red-50 rounded-xl border border-red-200 p-4 text-center">
                  <p className="text-xs font-black text-red-700 mb-1">
                    🔒 Asiento {seleccionadosIda[0]?.replace('a', '')} — Bloqueado
                  </p>
                  {objBloqueadoDetalle && typeof objBloqueadoDetalle === 'object' && (
                    <div className="text-[10px] text-red-500 space-y-0.5 mt-2">
                      <p><span className="font-bold">Motivo:</span> {objBloqueadoDetalle.motivo || '—'}</p>
                      <p><span className="font-bold">Por:</span> {objBloqueadoDetalle.admin || '—'}</p>
                    </div>
                  )}
                </div>
                <button onClick={ejecutarAccion} disabled={loading} className="w-full py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-bold text-sm transition-colors">
                  {loading ? '...' : '🔓 Desbloquear asiento'}
                </button>
                <button onClick={() => { setSeleccionadosIda([]); setTipoDetalle(null); setModo('VENTA'); }} className="text-xs text-gray-400 hover:text-gray-600 transition-colors">
                  Cancelar
                </button>
              </div>
            )}

            {modo === 'BLOQUEO' && seleccionadosIda.length > 0 && (
              <div className="flex flex-col flex-1 h-full">
                <div className="flex-1 overflow-y-auto pr-1 space-y-3">
                  <div className="bg-red-50 p-3 rounded-lg border border-red-100">
                    <p className="text-[10px] font-bold text-red-700 mb-2">
                      ⛔ Bloqueando {seleccionadosIda.length} asiento(s): {seleccionadosIda.map(a => a.replace('a', '')).join(', ')}
                    </p>
                    <label className="text-[9px] font-bold text-red-500 uppercase block mb-1">Motivo del bloqueo</label>
                    <select
                      className="w-full p-2 border border-red-200 rounded text-xs outline-none focus:border-red-400 bg-white mb-2"
                      value={motivoBloqueo}
                      onChange={e => setMotivoBloqueo(e.target.value)}
                    >
                      <option value="">Seleccionar motivo...</option>
                      <option value="Asiento dañado">🔧 Asiento dañado</option>
                      <option value="Cortesía">🎁 Cortesía</option>
                      <option value="Mantenimiento">🛠️ Mantenimiento</option>
                      <option value="Uso interno">🏢 Uso interno</option>
                      <option value="otro">✏️ Otro (escribir abajo)</option>
                    </select>
                    {motivoBloqueo === 'otro' && (
                      <input type="text" className="w-full p-2 border border-red-200 rounded text-xs outline-none focus:border-red-400" placeholder="Describe el motivo..." onChange={e => setMotivoBloqueo(e.target.value)} />
                    )}
                  </div>
                </div>
                <div className="shrink-0 mt-3 border-t pt-3 bg-white">
                  <button onClick={ejecutarAccion} disabled={loading} className="w-full py-2.5 rounded font-bold text-white text-sm transition-transform active:scale-95 bg-red-500 hover:bg-red-600">
                    {loading ? '...' : '⛔ Confirmar Bloqueo'}
                  </button>
                </div>
              </div>
            )}

            {(modo === 'VENTA' || modo === 'REDONDO') && seleccionadosIda.length > 0 && (
              <div className="flex flex-col flex-1 h-full">
                <div className="flex-1 overflow-y-auto pr-1 space-y-3">
                  {modo === 'REDONDO' && (
                    <div className="bg-purple-50 p-2.5 rounded-lg border border-purple-100">
                      <p className="text-[10px] font-bold text-purple-700 mb-1"><FaRoute className="inline" /> Regreso: {viaje.destino} ➝ {viaje.origen}</p>
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="text-[9px] font-bold text-purple-500 uppercase">📅 Fecha</label>
                          <input type="date" min={viaje.fecha} className="w-full p-1.5 border border-purple-200 rounded text-xs outline-none focus:border-purple-400" value={fechaRegreso} onChange={e => setFechaRegreso(e.target.value)} />
                        </div>
                        {fechaRegreso && (
                          <div>
                            <label className="text-[9px] font-bold text-purple-500 uppercase"><FaClock className="inline" /> Horario</label>
                            {buscandoRegresos ? (
                              <div className="text-[10px] text-purple-400 font-bold mt-1">Buscando...</div>
                            ) : viajesRegresoOpciones.length > 0 ? (
                              <select className="w-full p-1.5 border border-purple-200 rounded text-[11px] font-bold text-purple-900 outline-none focus:border-purple-400" value={regresoSeleccionado} onChange={e => setRegresoSeleccionado(e.target.value)}>
                                <option value="" disabled>Seleccionar...</option>
                                {viajesRegresoOpciones.map(op => (<option key={op.id} value={op.id}>{op.hora} (Libres: {16 - ((op.ocupados?.length || 0) + (op.bloqueados?.length || 0))})</option>))}
                              </select>
                            ) : (
                              <div className="text-[9px] text-red-500 font-bold mt-1">Sin viajes disponibles.</div>
                            )}
                          </div>
                        )}
                      </div>
                      {regresoSeleccionado && seleccionadosRegreso.length < seleccionadosIda.length && (
                        <p className="text-[10px] text-red-500 font-bold mt-2 text-center animate-pulse">Falta seleccionar {seleccionadosIda.length - seleccionadosRegreso.length} asiento(s) en el mapa de REGRESO</p>
                      )}
                    </div>
                  )}

                  <div className="space-y-2 border-t pt-2 border-gray-100">
                    {seleccionadosIda.map((asiento, idx) => {
                      const asientoVuelta = modo === 'REDONDO' && seleccionadosRegreso[idx] ? ` | Vuelta: ${seleccionadosRegreso[idx].replace('a', '')}` : '';
                      return (
                        <div key={asiento} className="bg-gray-50 p-2 rounded border border-gray-100">
                          <label className="text-[9px] font-bold text-gray-500 uppercase">Pasajero {idx + 1} (Ida: {asiento.replace('a', '')}{asientoVuelta})</label>
                          <input autoFocus={idx === 0} type="text" className="w-full p-1.5 rounded bg-white border text-xs outline-none focus:border-blue-400 mt-1" placeholder="Nombre completo" value={nombresPax[asiento] || ''} onChange={e => handleNombreChange(asiento, e.target.value)} />
                        </div>
                      );
                    })}
                    <div className="p-2">
                      <label className="text-[9px] font-bold text-gray-500 uppercase">WhatsApp Titular</label>
                      <input type="tel" className="w-full p-1.5 border rounded text-xs outline-none focus:border-green-400 mt-1" placeholder="Ej: 9541234567" value={telefonoPax} onChange={e => setTelefonoPax(e.target.value)} />
                    </div>

                    {/* Canal de venta */}
                    <div className="p-2 bg-blue-50 rounded-lg border border-blue-100">
                      <label className="text-[9px] font-bold text-blue-600 uppercase block mb-1">📋 Canal de venta</label>
                      <select className="w-full p-1.5 border border-blue-200 rounded text-xs outline-none focus:border-blue-400 bg-white mb-1" value={canalVenta} onChange={e => setCanalVenta(e.target.value)}>
                        <option value="taquilla">🏪 En taquilla</option>
                        <option value="telefono">📞 Reserva telefónica</option>
                        <option value="whatsapp">📱 WhatsApp</option>
                        <option value="otro">✏️ Otro</option>
                      </select>
                      {canalVenta === 'otro' && (
                        <input type="text" className="w-full p-1.5 border border-blue-200 rounded text-xs outline-none mb-1" placeholder="Especificar canal..." value={canalVentaOtro} onChange={e => setCanalVentaOtro(e.target.value)} />
                      )}
                      <label className="text-[9px] font-bold text-blue-600 uppercase block mb-1">👤 Atendido por</label>
                      <input type="text" className="w-full p-1.5 border border-blue-200 rounded text-xs outline-none focus:border-blue-400 bg-white" placeholder="Nombre del taquillero" value={atendidoPor} onChange={e => setAtendidoPor(e.target.value)} />
                    </div>
                  </div>
                </div>

                <div className="shrink-0 mt-3 border-t pt-3 bg-white">
                  <div className="flex justify-between items-center mb-2 px-1">
                    <span className="text-xs text-gray-500 font-bold">Total ({seleccionadosIda.length} pax):</span>
                    <span className="text-xl font-black text-gray-800">${totalACobrar}</span>
                  </div>
                  <button onClick={ejecutarAccion} disabled={loading} className="w-full py-2.5 rounded font-bold text-white text-sm transition-transform active:scale-95 bg-emerald-600 hover:bg-emerald-700">
                    {loading ? '...' : '💵 Cobrar Boletos'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalAsientos;